import { render } from "./03_DashobardSectionPaymentMethod.vue?vue&type=template&id=f4ffa760"
import script from "./03_DashobardSectionPaymentMethod.vue?vue&type=script&lang=js"
export * from "./03_DashobardSectionPaymentMethod.vue?vue&type=script&lang=js"

import "./03_DashobardSectionPaymentMethod.vue?vue&type=style&index=0&id=f4ffa760&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__